module.exports = __webpack_public_path__ + "media/react/components/Sequence/assets/plus-5260e8dbb14f27e57ec2284ed54a17eb.svg";